const host = '/api/'

export default {
    data: `${host}group`,
    data2: `${host}group2`,
    panorama: `${host}panorama`,
    panorama2: `${host}panorama2`,
    homeVideo: `${host}index-panorama`,
    config: `${host}config`,
}